/** Canonical site locale used when none can be resolved from URL, cookie, or IP. */
export const DEFAULT_SITE_LOCALE = "en-gb";

/** Returns the configured default locale, or DEFAULT_SITE_LOCALE if it is missing. */
export function resolveSiteDefaultLocale(configured?: unknown): string {
  return typeof configured === "string" && configured.length > 0 ? configured : DEFAULT_SITE_LOCALE;
}
